// Section14.jsx - Professional FAQs
import React, { useEffect, useRef, useState } from 'react';

const useReveal = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
};

const Section18 = () => {
  const [open, setOpen] = useState(null);
  const [headRef, headVisible] = useReveal();

  const faqs = [
  {
    q: "What does a mobile app development company do?",
    a: "A mobile app development company designs, develops, tests, deploys, and supports mobile applications for businesses. Services typically include strategy, UI/UX design, development, integrations, and maintenance."
  },
  {
    q: "How much do mobile app development services cost?",
    a: "Costs vary depending on features, complexity, platforms, integrations, and project scope. Custom applications require a detailed evaluation before accurate estimates can be provided."
  },
  {
    q: "How long does a mobile application development service project take?",
    a: "Development timelines depend on project complexity. Simple applications may take a few months, while enterprise-grade solutions typically require longer development cycles."
  },
  {
    q: "Do you provide custom mobile application development?",
    a: "Yes. Mean3 specializes in custom mobile application development tailored to unique business requirements, workflows, and growth objectives."
  },
  {
    q: "What platforms do your mobile app development services support?",
    a: "We develop applications for Android, iOS, and cross-platform environments using modern frameworks and technologies."
  },
  {
    q: "What is included in your android app development service?",
    a: "Our android app development service includes strategy, design, development, testing, deployment, integrations, and ongoing support."
  },
  {
    q: "What is the difference between an android app development service and an android application development service?",
    a: "The terms are often used interchangeably. Both refer to creating custom Android-based applications designed to meet specific business goals and user requirements."
  },
  {
    q: "Do you offer iOS app development services for businesses?",
    a: "Yes. Our iOS app development services include custom iPhone and iPad applications, enterprise solutions, ecommerce platforms, and customer engagement tools."
  },
  {
    q: "Can you build ecommerce mobile applications?",
    a: "Absolutely. Our ecommerce mobile application development services include shopping apps, payment integrations, loyalty programs, inventory management, and customer engagement features."
  },
  {
    q: "Do you provide support after launch?",
    a: "Yes. We offer ongoing maintenance, monitoring, updates, security improvements, and feature enhancements to ensure continued success."
  }
];

  return (
    <section className="bg-white py-[20px] md:py-20">
      <div className="max-w-4xl mx-auto px-6">
        <div
          ref={headRef}
          className={`text-center mb-14 transition-all duration-700 ${
            headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="text-[#cd2122] text-xs font-semibold uppercase tracking-widest">FAQs</span>
          <h2 className="text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] mt-3 leading-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${
                  isOpen ? 'border-[#cd2122]' : 'border-gray-200'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full text-left px-7 py-6 flex justify-between items-center hover:bg-gray-50 transition-colors"
                >
                  <h3 className="text-[16px] font-semibold text-[#1a1a1a]">{faq.q}</h3>
                  <span
                    className={`text-2xl text-[#cd2122] flex-shrink-0 ml-4 transition-transform duration-300 ${
                      isOpen ? 'rotate-45' : ''
                    }`}
                  >
                    +
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-7 pb-7 text-[16px] text-[#535353] leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Section18;